import React from 'react';

import styles from './Divider.module.scss';

export const Divider = () => (
  <div className={styles.dividerContainer}>
    <div className={styles.divider}></div>
  </div>
);
